import { gql } from '@apollo/client'

import { CUSTOMER_ADDRESS_FRAGMENT } from './customer/address'
import { SHOP_CUSTOMER_SPREEDLY_CARD_FRAGMENT } from './shop/customerSpreedlyCard'
import { SHOP_SQUARE_CUSTOMER_CARD_FRAGMENT } from './shop/squareCustomerCard'

export const CUSTOMER_FRAGMENT = gql`
  fragment Customer on Customer {
    id
    email
    firstName
    fullName
    isAnonymous
    lastName
    phone
    signedUp
    primaryAddress {
      id
    }
    addresses {
      ...CustomerAddress
    }
    spreedlyCards {
      ...CustomerSpreedlyCard
    }
    squareCards {
      ...ShopSquareCustomerCard
    }
  }
  ${CUSTOMER_ADDRESS_FRAGMENT}
  ${SHOP_CUSTOMER_SPREEDLY_CARD_FRAGMENT}
  ${SHOP_SQUARE_CUSTOMER_CARD_FRAGMENT}
`
